import createRoute from '@widesk-ui/tools/createRoute';
import SliderModel from '@models/shop/SliderModel';

export default createRoute.splitView('/sliders', 'shop', 'SliderSplitView', SliderModel.localize('plural'));